module.exports = __webpack_public_path__ + "0b8eae014f7194401c7387b0468444be.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/preview (1).png
// module id = 710
// module chunks = 0